import React from 'react'
import { Route, Switch } from 'react-router'
import List from './routes/List/index'
import Detail from './routes/Detail/index'
import Form from './routes/Form/index'

export default function ArtistViews () {
  return (
    <Switch>
      <Route exact path='/artists' component={List} />
      <Route path='/artists/add' component={Form} />
      <Route path='/artists/:id' component={Detail} />
    </Switch>
  )
}